import React, { useState, useRef, useEffect } from 'react';
import '../../assets/vendor/css/pages/page-auth.css'
import { Link, useNavigate } from 'react-router-dom';

import SimpleReactValidator from 'simple-react-validator';
import { post } from '../../helpers/api_helper';
import { getToken } from '../../helpers/Helper';
import { POST_SIGN_UP, POST_GET_COUNTRIES } from '../../helpers/url_helper';
import { toast } from 'react-toastify';

import Auth_Img from './../../assets/img/auth_img.png';
import { useTranslation } from 'react-i18next';
import Logo from './../../assets/img/logo.svg';

const Register = (props) => {
    const { t } = useTranslation();

    const navigate = useNavigate();
    useEffect(() => {
        if (getToken()) {
            navigate("/dashboard");
        }
        getCountries();
    }, [navigate])


    const simpleValidator = useRef(new SimpleReactValidator());

    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [CountriesList, SetCountriesList] = useState([]);
    const [SignUpSuccess, SetSignUpSuccess] = useState(false);
    const [form_inputs, setInputs] = useState({ email: '', name: '', companyName: '', password: '', c_password: '', countryId: '', tc : '' });
    const [, forceUpdate] = useState();

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_SIGN_UP, form_inputs);
            if (res_data.status) {
                SetSignUpSuccess(true);
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    // form submit event
    const resendEmail = async (event) => {
        event.preventDefault();
        SetButtonDisabled(true);
        var res_data = await post(POST_SIGN_UP, form_inputs);
        if (res_data.status) {
            toast('Email sent successfully.');
        } else {
            toast.error(res_data.message);
        }
        SetButtonDisabled(false);
    }

    // input text change handler
    const handleInputChange = (event) => {
        event.persist();
        if(event.target.name === 'tc'){
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: (event.target.checked)? true : '' }));
        }else{
            setInputs(inputs => ({ ...form_inputs, [event.target.name]: event.target.value }));
        }
    }

    const getCountries = async (event) => {
        var res_data = await post(POST_GET_COUNTRIES, {});
        if (res_data.status) {
            SetCountriesList(res_data.data.countriesList);
        }
    }

    return (
        <>
            <div>

            </div>
            <div className="authentication-wrapper authentication-cover">
                <div className="authentication-inner row m-0">
                    <div className="d-none d-lg-flex col-lg-7 col-xl-8 align-items-center p-5">
                        <div className="w-100 d-flex justify-content-center">
                            <img src={Auth_Img} className="img-fluid" alt="Login " width="700" />
                        </div>
                    </div>

                    <div className="d-flex col-12 col-lg-5 col-xl-4 align-items-center authentication-bg p-sm-5 p-4">
                        <div className="w-px-400 mx-auto">

                            {SignUpSuccess && <div className='text-center'>
                                <h3 className='mb-4'>{t('signUp.success.title')}</h3>
                                <p>{t('signUp.success.subTitle')}</p>
                                <p><b>{form_inputs.email}</b></p>
                                <div dangerouslySetInnerHTML={{ __html: t('signUp.success.instructions') }}></div>
                                <button disabled={ButtonDisabled} onClick={resendEmail} type="submit" className="btn btn-primary btn-block1 mb-3 mt-3 pl-4 pr-4"> {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('signUp.success.resendVerificationEmail')}</button>
                                <p> <Link to='/' className="a-link">{t('signUp.success.goToSignIn')}</Link></p>
                            </div>}

                            {!SignUpSuccess && <>
                                <div className="app-brand mb-5">
                                    <img src={Logo} alt='Cheque Print' style={{"width" : '300px'}} /> 
                                </div>

                                <h4 className="mb-2">{t('signUp.Title')}</h4>
                                <p className="mb-4">{t('signUp.SubTitle')}</p>

                                <form className="mb-3" onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label for="email" >{t('signUp.form.fullName')}</label>
                                        <input name="name" value={form_inputs.name} onChange={handleInputChange} className="form-control" placeholder={t('signUp.Placeholder.fullName')} type="text" />
                                        {simpleValidator.current.message('', form_inputs.name, 'required',{messages : {
                                            required : t('signUp.formError.fullNameRequired')
                                        }})}
                                    </div>
                                    <div className="mb-3">
                                        <label for="email" >{t('signUp.form.companyName')}</label>
                                        <input name="companyName" value={form_inputs.companyName} onChange={handleInputChange} className="form-control" placeholder={t('signUp.Placeholder.companyName')} type="text" />
                                        {simpleValidator.current.message('', form_inputs.companyName, 'required',{messages : {
                                            required : t('signUp.formError.companyNameRequired')
                                        }})}
                                    </div>
                                   
                                    <div className="mb-3">
                                        <label for="email" >{t('signUp.form.selectCountry')}</label>
                                        <select name="countryId" value={form_inputs.countryId} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('signUp.form.selectCountry')}</option>
                                            {CountriesList && CountriesList.map((value, index) => {
                                                return (<option key={index} value={value.countryId}>{value.countryName}</option>)
                                            })}
                                        </select>
                                        {simpleValidator.current.message('country', form_inputs.countryId, 'required', {messages : {
                                            required : t('signUp.formError.countryRequired')
                                        }})}
                                    </div>
                                    <div className="mb-3">
                                        <label for="mobileNo" >{t('signUp.form.mobileNumber')}</label>
                                        <input name="mobileNo" value={form_inputs.mobileNo} onChange={handleInputChange} className="form-control" placeholder={t('signUp.Placeholder.mobileNumber')} type="text" />
                                        {simpleValidator.current.message('', form_inputs.mobileNo, 'required|numeric|min:10|max:10', {messages : {
                                            required : t('signUp.formError.mobileNumberRequired'),
                                            numeric : t('signUp.formError.mobileNumberNumeric'),
                                            min : t('signUp.formError.mobileNumberMin'),
                                            max : t('signUp.formError.mobileNumberMax'),
                                        }})}
                                    </div>
                                    <div className="mb-3">
                                        <label for="email" >{t('signUp.form.emailAddress')}</label>
                                        <input name="email" value={form_inputs.email} onChange={handleInputChange} className="form-control" placeholder={t('signUp.Placeholder.emailAddress')} type="text" />
                                        {simpleValidator.current.message('email', form_inputs.email, 'required|email', {messages : {
                                            required : t('signUp.formError.emailAddressRequired'),
                                            email : t('signUp.formError.emailAddressValid'),
                                        }})}
                                    </div>
                                    <div className="mb-3">
                                        <label for="email" >{t('signUp.form.password')}</label>
                                        <input name="password" value={form_inputs.password} onChange={handleInputChange} type="password" className="form-control" placeholder={t('signUp.Placeholder.password')} />
                                        {simpleValidator.current.message('password', form_inputs.password, 'required', {messages : {
                                            required : t('signUp.formError.passwordRequired')
                                        }})}
                                    </div>
                                    <div className="mb-3">
                                        <label for="email" >{t('signUp.form.confirmPassword')}</label>
                                        <input name="c_password" value={form_inputs.c_password} onChange={handleInputChange} type="password" className="form-control" placeholder={t('signUp.Placeholder.confirmPassword')} />
                                        {simpleValidator.current.message('confirm password', form_inputs.c_password, `required|in:${form_inputs.password}`, { messages: { 
                                            required : t('signUp.formError.confirmPasswordRequired'),
                                            in: t('signUp.formError.confirmPasswordIn')
                                        } })}
                                    </div>
                                    <div className="mb-3">
                                        <div className="form-group form-check">
                                            <input type="checkbox" name='tc' className="form-check-input" onChange={handleInputChange} id="tc" />
                                            <label className="form-check-label" for="tc" dangerouslySetInnerHTML={{ __html: t('signUp.form.tc') }}></label>
                                        </div>
                                        {simpleValidator.current.message('Terms of service', form_inputs.tc, 'required', {messages : {
                                            required : t('signUp.formError.tcRequired')
                                        }})}
                                    </div>

                                    <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2 w-100">
                                        {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('signUp.signUp')}
                                    </button>
                                    <div className='mt-3'>
                                        <p className="text-center">
                                            <span>{t('signUp.alreadyHaveAnAccount')}</span>
                                            <Link to="/" className='text-primary'><span> {t('signUp.signInInstead')}</span></Link>
                                        </p>
                                    </div>
                                </form>
                            </>}

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default Register;